import React, { useEffect, useState } from 'react';
import './Webinaires.css';
import Hero from '../Hero/Hero';
import axios from 'axios';

const Webinaires = ({ renderHero }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [webinaires, setWebinaires] = useState([]);
  const [loading, setLoading] = useState(true);
  const itemsPerPage = 2; // Cartes plus grandes = moins par page

  const fetchWebinaires = async () => {
    setLoading(true);
    try {
      const response = await axios.get("https://ftlm.org.tn/webinaires");
      const files = await Promise.all(response.data.map(async (file) => {
        const blobResponse = await axios.get(
          `https://ftlm.org.tn/webinaires/${file.id}/download`,
          { responseType: "blob" }
        );
        return {
          ...file,
          data: URL.createObjectURL(blobResponse.data),
        };
      }));
      setWebinaires(files);
    } catch (error) {
      console.error("Erreur lors de la récupération des webinaires", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWebinaires();
  }, []);

  // =========================================================
  // MODIFICATION CLÉ: Suppression du Scroll Vertical
  // =========================================================
  useEffect(() => {
    // 1. Ajout de la classe CSS qui supprime le scroll au body
    document.body.classList.add('webinaires-no-scroll');

    // 2. Retrait de la classe lors du démontage pour réactiver le scroll ailleurs
    return () => {
      document.body.classList.remove('webinaires-no-scroll');
    };
  }, []); 
  // =========================================================

  const totalPages = Math.ceil(webinaires.length / itemsPerPage);

  const currentItems = webinaires.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const changePage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <div className="webinaires-pageee">
      {renderHero && <Hero />}
      <div className="publications-containerr">
        {loading ? (
          <div className="spinner-container">
            <div className="spinner"></div>
          </div>
        ) : (
          <>
            <div className="webinaires-grid">
              {currentItems.map((event, index) => (
                <div key={index} className="webinaire-card">
                  <img src={event.data} alt={`Webinaire ${index + 1}`} className="webinaire-image" />
                  <div className="webinaire-content">
                    <h2 className="webinaire-title">{event.titre}</h2>
                    <p className="webinaire-link">{event.lien}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="pagination">
              <button onClick={() => changePage(currentPage - 1)} disabled={currentPage === 1}>
                ◀
              </button>
              {Array.from({ length: totalPages }, (_, i) => (
                <button
                  key={i}
                  onClick={() => changePage(i + 1)}
                  className={currentPage === i + 1 ? 'active' : ''}
                >
                  {i + 1}
                </button>
              ))}
              <button onClick={() => changePage(currentPage + 1)} disabled={currentPage === totalPages}>
                ▶
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Webinaires;